export class AppFuncionesService {

    constructor(
     
    ) { }

    fechaLetras(fechaString:string) {
        if (fechaString != undefined && fechaString != null && fechaString != '') {
          var split = fechaString.split("/");
          if (split.length == 3) {
            var fecha = new Date(split[1]+'/'+split[0]+'/'+split[2]);
            var options :any = { year: 'numeric', month: 'long', day: 'numeric' };
            return  fecha.toLocaleDateString("es-ES", options).toUpperCase();
          }
          return '';
        } else {
          return '';
        }
    }   

}